// Simple logger utility for development
type LogLevel = 'trace' | 'debug' | 'info' | 'warn' | 'error';

const LOG_LEVELS: Record<LogLevel, number> = {
  trace: 0,
  debug: 1,
  info: 2,
  warn: 3,
  error: 4,
};

// Get log level from environment or default to 'info'
const currentLogLevel = (import.meta.env.VITE_LOG_LEVEL as LogLevel) || 'info';
const currentLogLevelValue = LOG_LEVELS[currentLogLevel] || LOG_LEVELS.info;

export const createLogger = (name: string) => {
  const log = (level: LogLevel, ...args: any[]) => {
    if (LOG_LEVELS[level] >= currentLogLevelValue) {
      const timestamp = new Date().toISOString();
      const prefix = `[${timestamp}] [${level.toUpperCase()}] [${name}]`;
      
      switch (level) {
        case 'error':
          console.error(prefix, ...args);
          break;
        case 'warn':
          console.warn(prefix, ...args);
          break;
        case 'debug':
          console.debug(prefix, ...args);
          break;
        case 'trace':
          console.trace(prefix, ...args);
          break;
        default:
          console.log(prefix, ...args);
      }
    }
  };

  return {
    trace: (...args: any[]) => log('trace', ...args),
    debug: (...args: any[]) => log('debug', ...args),
    info: (...args: any[]) => log('info', ...args),
    warn: (...args: any[]) => log('warn', ...args),
    error: (...args: any[]) => log('error', ...args),
  };
};